module.exports = __webpack_public_path__ + "static/media/unmute.3e0f7c9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/unmute.svg
// module id = 50
// module chunks = 0